import React, { useState, useEffect, useRef } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import { OverlayTrigger, Popover } from "react-bootstrap";
import moment from "moment";

import MBOTLogo from "../../../assets/logo/descLogo.png";
import BellIcon from "../../../assets/misc/bellIcon.png";
import dummyProfile from "../../../assets/misc/dummyProfile.png";
import DonwlodButton from "../../../components/buttons/DonwlodButton";
import { sidebarItems } from "../../../lib/Sidebar/Sidebar";
import DateRangePicker from "../../../components/DatePicker/DateRangePicker";
import "./AtpMasterLayout.css";
import useLogout from "../../../hooks/useLogout";
import { MdOutlineLogout } from "react-icons/md";
import NotificationPopUp from "../../../pages/Notifications/notificationCenter/NotificationPopUp";
import { notificationService } from "../../../services/notificationService";
import { fetchDashboardMetrics } from "../../../redux/slices/atpSlice";

const MasterLayout = () => {
  const initialValues = {};
  const location = useLocation();
  const userType = useSelector((state) => state.auth.user?.user_type);
  const { handleLogOut } = useLogout(userType);
  const [notifications, setNotifications] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const popupRef = useRef();
  const [showBadge, setShowBadge] = useState(false);
  const dispatch = useDispatch();
  const [trendYear, setTrendYear] = useState(
    moment(new Date().toISOString()).year()
  );
  const startDate = useSelector((state) => state.atp.startDate);
  const endDate = useSelector((state) => state.atp.endDate);
  const is_profile_completed = useSelector(
    (state) => state.auth.user?.is_profile_completed
  );

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await notificationService.getAllNotifications(1, 3);
        const fetchedNotifications = response?.data?.data?.data;
        setNotifications(fetchedNotifications);

        if (fetchedNotifications.length > 0) {
          const latestNotificationId = fetchedNotifications[0].id;
          const storedNotificationId = localStorage.getItem("latestNotificationId");


          if (storedNotificationId && latestNotificationId !== storedNotificationId) {
            setShowBadge(true);
          } else {
            console.warn("No new notifications.");
          }

          localStorage.setItem("latestNotificationId", latestNotificationId);
        }
      } catch (error) {
        console.error("Error fetching notifications: ", error);
      }
    };

    fetchNotifications();
    const interval = setInterval(fetchNotifications, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleClosePopup = () => {
    setShowPopover(false);
    setShowBadge(false);
  };

  useEffect(() => {
    setShowBadge(false);
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.startsWith("/atp")) {
      if (startDate && endDate) {
        dispatch(
          fetchDashboardMetrics({
            start_date: startDate,
            end_date: endDate,
            trend_year: trendYear,
          })
        )
      };
    }
  }, [location, dispatch, startDate, endDate, trendYear]);

  const adjustedSidebarItems = sidebarItems[userType]?.filter((item) => {
    if (!is_profile_completed && item.name === "Resources") {
      return false;
    }
    return true;
  }) || [];

  return (
    <>
      {" "}
      <div id="wrapper">
        {/* Sidebar Container::start */}
        <aside className="sidebar-container d-lg-flex d-none">
          {/* Sidebar Overlay::start */}
          <div className="sidebar-overlay">
            <img src={MBOTLogo} alt="MBOT Logo" className="overlay-header-logo" />
            <div className="d-flex flex-column">
              <div className="d-flex flex-column mt-3 cursor-pointer text-gray-250 fw-500 fs-6 sidebar-items">
                {adjustedSidebarItems?.map((item, index) => (
                  <NavLink
                    key={item?.name}
                    to={item.path}
                    className={`text-decoration-none  text-gray-250 ${location.pathname === item?.path ? "active" : ""
                      }`}
                  >
                    <div className="border_bottom">
                      <span>{item.name}</span>
                    </div>
                  </NavLink>
                ))}
              </div>
              <div
                className="dropdown"
                style={{
                  bottom: 0,
                  position: "absolute",
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="center-alignment cursor-pointer gap-2 account_profile"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={dummyProfile} width={36} alt="Profile" />
                  Account
                </div>
                <ul className="dropdown-menu" style={{ border: "none" }}>
                  <div
                    onClick={handleLogOut}
                    className="text-gray-300 center-alignment account_profile cursor-pointer"
                  >
                    <MdOutlineLogout className="sidebar-item-icon" /> Logout
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </aside>
        {/* Page Content Section::start */}
        <section className="page-content">
          {/* Navbar Container::start */}

          <nav
            className="nav-container"
            style={{
              backgroundColor: "#fff",
              height: "82px",
              width: "100%",
            }}
          >
            <div className="napadding">
              <div className="d-flex main_navdiv">
                <div className="formdata">
                  <Formik initialValues={initialValues}>
                    <Form>
                      <div className="search">
                        <span className="fa-search">
                          <FaSearch />
                        </span>
                        <Field
                          type="text"
                          name="title"
                          className="form-control"
                          autoComplete="off"
                          placeholder="Search Here.."
                        />
                      </div>
                    </Form>
                  </Formik>
                </div>
                <div className="d-flex flex-div">
                  <div style={{ visibility: location.pathname === '/atp/dashboard' ? 'visible' : 'hidden' }}>
                    {" "}
                    <DonwlodButton />
                  </div>
                  <div className="pl-75">
                    {" "}
                    <DateRangePicker />
                  </div>
                  {/* <div className="ballicn">
                    {" "}
                    <img
                      src={BellIcon}
                      alt="Notifications"
                      className="cursor-pointer  ml-auto"
                    />
                  </div> */}
                  <div ref={popupRef} style={{ cursor: "pointer" }}>
                    <OverlayTrigger
                      trigger="click"
                      placement="bottom-end"
                      show={showPopover}
                      onToggle={() => setShowPopover(!showPopover)}
                      overlay={
                        <Popover id={`${userType === 3 ? 'avatar-popover-1' : 'avatar-popover'}`} className="dashboard-avatar-popover">
                          <Popover.Body style={{ maxWidth: "500px !important" }}>
                            <NotificationPopUp handleClosePopup={handleClosePopup} userType={userType} />
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <span className="position-relative">
                        <img src={BellIcon} alt="Notifications" className="cursor-pointer" />
                        {showBadge && (
                          <span className="position-absolute notification-badge translate-middle p-1 bg-danger border border-light rounded-circle">
                            <span className="visually-hidden">New alerts</span>
                          </span>
                        )}
                      </span>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          {/* Main Content Start */}
          <main className="main-content">
            <Outlet />
          </main>
        </section>
      </div>
    </>
  );
};

export default MasterLayout;
